import FW from '../fw/fw';
import Logger from '../fw/logger';

export default class AdBlocker {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static hasAdblock() {
    return new Promise(resolve => {
      const urlsArray = [
        'https://securepubads.g.doubleclick.net/pagead/ppub_config',
        'https://ads.stickyadstv.com/user-registering',
        'https://static.criteo.net/images/pixel.gif?ch=2'
      ];
      const index = FW.getRandomInt(0, urlsArray.length);
      const url = urlsArray[index];
      FW.ajax(url, false, 'HEAD').
        then(data => {
          if (data === '') {
            Logger.print('advertisement', 'no adblocker detected');
            resolve(false);
          } else {
            Logger.print('advertisement', 'adblocker detected');
            resolve(true);
          }
        }).catch(() => {
          Logger.print('advertisement', 'adblocker detected');
          resolve(true);
        });
    });
  }

  static adBlockButtonCallback(event) {
    Logger.print('advertisement', 'adblock disabled by viewer - reload page');
    FW.eventStopPrevent(event);
    window.location.reload();
  }

  initAdBlockDetectionPreventPlayback() {
    const adsLabel = this.#rmp.labels.ads;
    const rtl = this.#rmp.rtl;
    this.#rmp.on('adblock', () => {
      Logger.print('advertisement', 'adblock detected - show custom message and prevent playback');
      const adBlockMessageElement = FW.createElement('div', 'rmp-ad-block-container');
      const adBlockMessage = FW.createElement('div', 'rmp-ad-block-message');
      const adBlockDetectedText = FW.createElement('div',
        'rmp-ad-block-text',
        adsLabel.adBlockDetectedMessage,
        rtl);
      const adBlockDetectedTextExtended = FW.createElement('div',
        'rmp-ad-block-text-extended',
        adsLabel.adBlockMessageMessageExtended,
        rtl);
      const adBlockerImage = FW.createElement('div', 'rmp-ad-block-image');
      adBlockerImage.innerHTML = '<svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="49" cy="49" r="49" fill="#EF5350"></circle><circle cx="34" cy="35" r="6" fill="#2C2C32"></circle><circle cx="64" cy="35" r="6" fill="#2C2C32"></circle><path d="M28 70C28 70 44.5 59 69 59" stroke="#2C2C32" stroke-width="7" stroke-linecap="round"></path></svg>';
      const adBlockButton = FW.createElement(
        'div',
        'rmp-ad-block-button',
        adsLabel.adBlockDetectedButton,
        rtl
      );
      adBlockButton.setAttribute('role', 'button');
      FW.addEvents(['touchend', 'click'], adBlockButton, AdBlocker.adBlockButtonCallback);
      adBlockMessage.appendChild(adBlockDetectedText);
      adBlockMessage.appendChild(adBlockDetectedTextExtended);
      adBlockMessageElement.appendChild(adBlockerImage);
      adBlockMessageElement.appendChild(adBlockMessage);
      adBlockMessageElement.appendChild(adBlockButton);
      this.#rmp.dom.container.appendChild(adBlockMessageElement);
      this.#rmp.controls = false;
      this.#rmp.one('play', () => {
        Logger.print('advertisement', 'adblock detected - prevent playback');
        this.#rmp.destroy().catch(error => {
          this.#rmp.rmpUtils.warning(1022, error);
        });
      });
      this.#rmp.one('adstarted', () => {
        Logger.print('advertisement', 'adblock detected - prevent playback');
        this.#rmp.destroy().catch(error => {
          this.#rmp.rmpUtils.warning(1022, error);
        });
      });
    });
  }

}
